// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"765":"bf7bfe2e","777":"90cc989a","987":"90cc989a"}[chunkId] + ".chunk.css";
};